import React from 'react'
import { Card, CardContent, Typography, Box } from '@mui/material'
import dayjs from 'dayjs'

const CardPeriodo = ({ dados }) => {
  const dataInicio = dados?.dtInicio
    ? dayjs(dados.dtInicio).format('DD/MM/YYYY')
    : '--/--/----'

  const dataFim = dados?.dtFim
    ? dayjs(dados.dtFim).format('DD/MM/YYYY')
    : '--/--/----'

  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderRadius: 3,
      }}
    >
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Período
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mt: 1,
          }}
        >
          <Box>
            <Typography fontSize={15} fontWeight="400">
              {dataInicio} - {dataFim}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default CardPeriodo
